import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group'

class MainBox extends Component {

    constructor(props) {
        super(props);
        this.state = {
            
            prevDepth: this.getPathDepth(this.props.location)
        };
    }

    componentWillReceiveProps() {
        //When props are updated, update the current path 
        //props supplies us with the location object which has a router location info
        this.setState({ prevDepth: this.getPathDepth(this.props.location) });
    }
    
    getPathDepth(location) {
        let pathArr = location.pathname.split("/");
        pathArr = pathArr.filter(n => n !== "");
        return pathArr.length;
    }
    
    render() {

        const { location } = this.props;

        console.log(location.pathname);
        
        /*Used to track if the page path did change so when can re-render the routes to apply animation */
        const currentKey = location.pathname;
        //Specify the duration of the animation (on enter and on exit)
        const timeout = { enter: 800, exit: 400 };

        return (
            <TransitionGroup component="div" className="App">
                <CSSTransition
                key={currentKey}
                timeout={timeout}
                classNames="pageSlider"
                mountOnEnter={false}
                unmountOnExit={true}
                >
                <div className={
                    this.getPathDepth(location) - this.state.prevDepth >= 0
                    ? "left"
                    : "right"
                }>
                    {this.props.children}
                </div>
                </CSSTransition>
            </TransitionGroup>
        )
    }
}
export default withRouter(MainBox);